/**
 * Task #40 — pure overflow split for email pulse participant chips.
 * Sender chip(s) always visible, then up to `maxInline` To/CC chips;
 * the rest go behind a "+X more" popover.
 */
export interface OverflowParticipant {
  kind: 'from' | 'to' | 'cc';
}

export const MAX_INLINE_NON_SENDER = 3;

export function splitParticipantsForDisplay<T extends OverflowParticipant>(
  participants: T[],
  maxInline: number = MAX_INLINE_NON_SENDER,
): { inline: T[]; overflow: T[] } {
  const senders = participants.filter(p => p.kind === 'from');
  const rest = participants.filter(p => p.kind !== 'from');
  return {
    inline: [...senders, ...rest.slice(0, maxInline)],
    overflow: rest.slice(maxInline),
  };
}
